import { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  Typography
} from '@mui/material';
import { postChangePassword } from 'src/servicios/sigma-core/sigma/Sigma_Account_Auth';
import { Sigma_Account_Auth } from 'src/models/sigma/Sigma_Account_Auth';

interface ChangePasswordPampaProps {
  handleCloseModalPassword: () => void;
  isOpenModalPassword: boolean;
  StructuredData: Sigma_Account_Auth;
}

function ChangePasswordPampa({
  handleCloseModalPassword,
  isOpenModalPassword,
  StructuredData
}: ChangePasswordPampaProps) {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (isOpenModalPassword) {
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
      setError('');
    }
  }, [isOpenModalPassword]);

  const handleClose = () => {
    handleCloseModalPassword();
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setError('Las contraseñas nuevas no coinciden.');
      return;
    }
    // Aquí iría la lógica para cambiar la contraseña

    const sigmaValue = {
      id: StructuredData.id,
      OLD_PASS: currentPassword,
      NEW_PASS: newPassword,
      _user: StructuredData.cliente
    };

    const result = await postChangePassword(sigmaValue)
      .then((values) => {
        return values;
      })
      .catch((error) => console.log(error));

    if (result) {
      alert('Contraseña cambiada correctamente.');
      handleClose();
    } else {
      setError(
        'Contraseña actual incorrecta o error al cambiar la contraseña.'
      );
      return;
    }
  };

  return (
    <Dialog
      open={isOpenModalPassword}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle>Cambiar contraseña</DialogTitle>

      <DialogContent>
        <Box display="flex" flexDirection="column" gap={2}>
          <TextField
            label="Contraseña actual"
            type="password"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            required
            fullWidth
            autoFocus
            sx={{ marginTop: 5 }}
          />
          <TextField
            label="Nueva contraseña"
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
            fullWidth
          />
          <TextField
            label="Confirmar nueva contraseña"
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            fullWidth
          />
          {newPassword !== confirmPassword && newPassword != '' && (
            <Typography color="error" variant="body2">
              Las contraseñas no coinciden.
            </Typography>
          )}
          {error && (
            <Typography color="error" variant="body2">
              {error}
            </Typography>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          Cancelar
        </Button>
        <Button
          type="button"
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={
            !currentPassword || !newPassword || newPassword != confirmPassword
          }
        >
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ChangePasswordPampa;
